import { StandardEvents } from '@shopify/events';

// Reuse the server-rendered colour field and its native required select.
// Palette values remain canonical Shopify line-item property values.
if (!window.__pfVariantColours) {
  window.__pfVariantColours = true;
  const requests = new WeakMap();
  document.addEventListener(StandardEvents.productSelect, event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const section = event.target.closest('.shopify-section');
    if (!section || !event.promise) return;
    const token = {};
    requests.set(section, token);
    event.promise.then(({ detail }) => {
      if (requests.get(section) !== token || !section.isConnected || !detail?.html) return;
      for (const field of section.querySelectorAll('[data-pf-colour-grid][data-pf-variant-palettes]')) {
        const select = field.querySelector('[data-pf-grid-select]');
        if (!select) continue;
        const nextSelect = detail.html.getElementById(select.id);
        const source = nextSelect?.closest('[data-pf-colour-grid]');
        if (!source) continue;
        const value = select.value;
        const focused = field.contains(document.activeElement);
        const next = source.cloneNode(true);
        const nextNative = next.querySelector('[data-pf-grid-select]');
        nextNative.value = [...nextNative.options].some(o => o.value === value && !o.disabled) ? value : '';
        field.replaceWith(next);
        next.dispatchEvent(new CustomEvent('pf:colour-field-replaced', { bubbles: true }));
        nextNative.dispatchEvent(new Event('change', { bubbles: true }));
        if (focused) (next.querySelector('[data-pf-grid-option][tabindex="0"]') || nextNative).focus();
      }
    }).catch(error => {
      if (error?.name !== 'AbortError') console.warn('Design colour update failed', error);
    });
  });
}
